import React from 'react'
import { Link } from 'react-router-dom'
import routes from '../../routes.json'
import ico_instagram from '../../assets/images/icons/insta.svg';
import ico_facebook from '../../assets/images/icons/facebook_white.svg';
import ico_twitter from '../../assets/images/icons/twitter_white.svg';

const Footer = () => {
  const date = new Date();

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="row">
          <div className="col">
            <Link to={routes.ABOUT} className="footer-link">
              O Mně
            </Link>
            <Link to={routes.AROMATHERAPY} className="footer-link">
              Aromaterapie
            </Link>
            <Link to={routes.MASSAGE} className="footer-link">
              Masáže
            </Link>
          </div>
          <div className="col">
            <Link to={routes.WELLNESS} className="footer-link">
              Wellness
            </Link>
            <Link to={routes.PRICES} className="footer-link">
              Ceník
            </Link>
            <Link to={routes.CONTACT} className="footer-link">
              Kontakt
            </Link>
          </div>
          <div className="col contact-links">
            <a href="callto:+420776425809" className="footer-link-contact footer-link-call">
              +420 776 425 809
            </a>
            <a href="mailto:lucie@skokan.eu" className="footer-link-contact footer-link-mail">
              lucie@skokan.eu
            </a>
          </div>
          <div className="col socials">
            <a href="https://instagram.com" className="footer-link-social" target="_blank">
              <img src={ico_instagram} className="social-ico" alt="instagram" />
            </a>
            <a href="https://facebook.com" className="footer-link-social" target="_blank">
              <img src={ico_facebook} className="social-ico" alt="facebook" />
            </a>
            {/* <a href="https://twitter.com" className="footer-link-social" target="_blank">
              <img src={ico_twitter} className="social-ico" alt="twitter" />
            </a> */}
          </div>
        </div>
        <div className="row">
          <p className="copyright">
            © Lucie Skokanová, {`${date.getFullYear()}`}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;